export enum RouteName {
    HOME = "/",
    PARTNERS = "/partners",
    SOLUTIONS = "/solutions",
    CONTACT = "/contact",
    PRICE = '/price',
    ABOUT = "/about",
}
